function getMostInnerElementManifest(editorElement, pathArray) {
  var _editorElement$elemen;
  const [firstElement, ...remainingPath] = pathArray.slice(1);
  let innerElement = (_editorElement$elemen = editorElement.elements) == null ? void 0 : _editorElement$elemen[firstElement];
  if (!innerElement) {
    return null;
  }
  for (const key of remainingPath) {
    var _innerElement;
    if (innerElement && typeof innerElement === 'object' && (_innerElement = innerElement) != null && _innerElement.elements && key in innerElement.elements) {
      innerElement = innerElement.elements[key];
    } else {
      return null;
    }
  }
  return innerElement;
}
export function getElementManifestByInnerElementPath(manifest, innerElementPath) {
  if (!manifest || !(manifest != null && manifest.editorElement)) {
    return null;
  }
  if (!innerElementPath || innerElementPath.length <= 1) {
    return manifest.editorElement;
  }
  return getMostInnerElementManifest(manifest.editorElement, innerElementPath);
}
//# sourceMappingURL=getElementManifestUtils.js.map